import React, { memo } from 'react';
import { View } from 'react-native';
import { isMobile } from 'react-device-detect';
import { createUseStyle } from '@redlink/assets/styles';
import { IconButton, IconDelete, IconEdit } from '@redlink/components/atoms';
import { RadioButton } from '@redlink/components/molecules';

export const RadioButtonGroup = memo(
  ({
    item: { title },
    withAction = true,
    style,
    onSelectItem,
    onDeletePress,
    onEditPress,
    isSelected,
    noContainer,
    iconSize,
    ...rest
  }) => {
    const { styles, colors } = useStyle();

    return (
      <View
        style={[
          styles.itemContainer,
          isSelected && !noContainer && styles.selectedItemContainer,
          noContainer && styles.noContainer,
          noContainer && isMobile && styles.noContainerMobile,
          style,
        ]}
        {...rest}
      >
        <RadioButton
          title={title}
          selected={isSelected}
          onPress={onSelectItem}
          style={styles.radioButton}
          {...{iconSize}}
        />
        {withAction && (
          <View style={styles.iconsContainer}>
            <IconButton transparent onPress={onDeletePress}>
              <IconDelete color={colors.gray23} />
            </IconButton>
            <IconButton transparent onPress={onEditPress}>
              <IconEdit color={colors.gray23} size={20} />
            </IconButton>
          </View>
        )}
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors, size }) => ({
  itemContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderColor: colors.black3,
    borderWidth: 1,
    borderRadius: 4,
    marginVertical: 4,
    height: 48,
    padding: 7,
  },
  selectedItemContainer: {
    backgroundColor: colors.blue8,
    borderColor: colors.blue8,
  },
  noContainer: {
    borderWidth: 0,
    height: 30,
  },
  noContainerMobile: {
    paddingHorizontal: 0,
  },
  radioButton: {
    flex: 3,
  },
  iconsContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
}));
